import {z} from 'zod'

export const CapacityBucketSchema = z.enum([
    '$1,000,000+',
    '$500,000 to $999,999',
    '$250,000 to $499,999',
    '$100,000 to $249,999',
    '$50,000 to $99,999',
    '$25,000 to $49,999',
    '$10,000 to $24,999',
    '$5,000 to $9,999',
    'Under $5,000',
])

export const capacityBucketValues = Object.values(CapacityBucketSchema) as CapacityBucket[]
export type CapacityBucket = z.infer<typeof CapacityBucketSchema>

export const ENGAGEMENT_KEYS = {
    'Very Engaged': z.number(),
    Engaged: z.number(),
    'Somewhat Engaged': z.number(),
    'Minimally Engaged': z.number(),
    Disengaged: z.number(),
} as const

export type EngagementLevel = keyof typeof ENGAGEMENT_KEYS
export const engagementLevelValues = Object.keys(ENGAGEMENT_KEYS) as EngagementLevel[]

export const EngagementRowSchema = z
    .object({
        capacity_bucket: CapacityBucketSchema,
        ...ENGAGEMENT_KEYS,
        total: z.number(),
    })
    .transform(({capacity_bucket, ...rest}) => ({
        ...rest,
        capacityBucket: capacity_bucket,
    }))

export const CrossTabSchema = z
    .object({
        rows: z.array(EngagementRowSchema),
        grand_total: z.number(),
    })
    .transform(({rows, grand_total}) => ({
        rows,
        grandTotal: grand_total,
    }))
